// Shown to guests when the photographer has turned the gallery off
// (event.galleryLive === false). The photographer still has full access via the
// webapp; only the guest-facing gallery is closed.
const GalleryUnavailable = () => {
  return (
    <div className="flex flex-col justify-center items-center h-full px-6">
      <div className="text-6xl md:text-8xl mb-4 opacity-20">🔒</div>
      <h1 className="text-xl md:text-4xl font-bold text-newDarkBlack dark:text-[#FAFAFA] mb-4 text-center">
        Gallery unavailable
      </h1>
      <p className="text-md md:text-md text-newOffBlack dark:text-offGrey text-center max-w-md leading-relaxed">
        This gallery isn't currently available. Please check back later or reach
        out to your photographer.
      </p>
    </div>
  )
}

export default GalleryUnavailable
